import { render, staticRenderFns } from "./api-img.vue?vue&type=template&id=528cbbe8&"
import script from "./api-img.vue?vue&type=script&lang=js&"
export * from "./api-img.vue?vue&type=script&lang=js&"
import style0 from "./api-img.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports